import React, { useState } from 'react'
import { autocompleteHelpers } from 'elentari'
import unidadeNegocioRepository from './unidadeNegocioRepository'
import Autocomplete from '../../components/Autocomplete'
const { toOption } = autocompleteHelpers

export const loadUnidadeNegocio = async inputValue => {
  const response = await unidadeNegocioRepository.list({
    query: {
      descricao: inputValue,
      status: true,
      order: 'descricao asc'
    },
    paginate: {
      limit: 10
    }
  })
  if (response.ok) {
    return response.data.map(toOption('descricao'))
  }
  return []
}

const UnidadeNegocioAutocomplete = props => {
  const [inputFocused, setInputFocused] = useState(false);

  const handleFocus = () => {
    if (!inputFocused) setInputFocused(true);
  };

  return (
    <Autocomplete
      {...props}
      repository={unidadeNegocioRepository}
      labelOption="descricao"
      loadOptions={inputFocused ? loadUnidadeNegocio : async () => []}
      onFocus={handleFocus}
      defaultOptions={false}
    />
  )
}

export default UnidadeNegocioAutocomplete
